export default {
  init () {
    this.lazyload()
  },
  lazyload () {
    let observer_img = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.src = entry.target.dataset.src
            observer.unobserve(entry.target)
          }
        })
      },
      { rootMargin: '200px 0px 200px 0px' }
    )
    
    let observer_srcset = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.srcset = entry.target.dataset.srcset
            observer.unobserve(entry.target)
          }
        })
      },
      { rootMargin: '400px 0px 400px 0px' }
    )

    // Images
    document.querySelectorAll('[data-src]').forEach(img => {
      observer_img.observe(img)
    })

    // Images, responsive sizes
    document.querySelectorAll('[data-srcset]').forEach(source => {
      observer_srcset.observe(source)
    })

    document.querySelectorAll('iframe[data-src]').forEach(iframe => {
      iframe.dataset.src === undefined ? observer_img.observe(iframe) : ''
    })
  }
}
